import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbProps {
  customTitle?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ customTitle }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  const siteUrl = 'https://ozarkselec.com';

  // Mapping des URLs vers des noms lisibles
  const breadcrumbNameMap: { [key: string]: string } = {
    'batiment': 'Bâtiment Général',
    'irve': 'IRVE - Bornes de Recharge',
    'maintenindus': 'Maintenance Industrielle',
    'habielec': 'Habilitation Électrique',
    'elecgnrle': 'Électricité Générale',
    'contact': 'Contact',
    'mentions-legales': 'Mentions Légales',
    'rse': 'RSE',
    'enseignes': 'Enseignes Lumineuses',
    'cgv': 'CGV'
  };

  const breadcrumbs = [
    { name: 'Accueil', path: '/' }
  ];

  let currentPath = '';
  pathnames.forEach((pathname) => {
    currentPath += `/${pathname}`;
    const name = customTitle || breadcrumbNameMap[pathname] || pathname;
    breadcrumbs.push({ name, path: currentPath });
  });

  // Masquer si on est sur l'accueil
  if (pathnames.length === 0) {
    return null;
  }

  // Schema BreadcrumbList JSON-LD
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((bc, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": bc.name,
      "item": `${siteUrl}${bc.path === '/' ? '' : bc.path}`
    }))
  };

  return (
    <div className="breadcrumb-mobile" style={{
      backgroundColor: 'var(--ozarks-light-gray)',
      padding: '8px 20px',
      borderBottom: '1px solid #E9ECEF',
      display: 'block'
    }}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <div className="t-container" style={{
        fontSize: '12px',
        color: 'var(--ozarks-gray)'
      }}>
        {breadcrumbs.map((breadcrumb, index) => (
          <span key={breadcrumb.path}>
            {index > 0 && (
              <span style={{ margin: '0 8px', color: 'var(--ozarks-gray)' }}>
                ›
              </span>
            )}
            {index === breadcrumbs.length - 1 ? (
              <span style={{ 
                color: 'var(--ozarks-blue-dark)', 
                fontWeight: 500 
              }}>
                {breadcrumb.name}
              </span>
            ) : (
              <Link 
                to={breadcrumb.path}
                style={{
                  color: 'var(--ozarks-gray)',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = 'var(--ozarks-blue-medium)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = 'var(--ozarks-gray)';
                }}
              >
                {breadcrumb.name}
              </Link>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumb;